<template>
  <div class="channel-flow-select-container">
    <div class="channel-flow-select-wrapper" @click="toggleDropdown">
      <div class="channel-flow-select-trigger">
        <div class="channel-flow-selected-option">
          <component
            v-if="value"
            :is="getIconComponent(value.type_key)"
            class="channel-flow-icon"
          />
          <span>
            {{ value ? value.name : getTranslations("expression_1402") }}
          </span>
        </div>
        <svg
          class="channel-flow-icon-dropdown"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      </div>

      <div
        v-if="isDropdownOpen"
        class="channel-flow-select-content-wrapper"
        :style="dropdownPosition"
      >
        <div class="channel-flow-select-content">
          <div
            v-for="type in channelConfigs.data.channel_types"
            :key="type.id"
            @click="selectChannel(type, $event)"
            class="channel-flow-select-item"
          >
            <component
              :is="getIconComponent(type.type_key)"
              class="channel-flow-icon"
            />
            <span>{{ type.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { UilWhatsapp, UilInstagram, UilFacebookF } from '@iconscout/vue-unicons';
import "../../../../js/assets/css/Channel-Flow/channel-flow.css"
export default {
  components: {
    UilWhatsapp,
    UilInstagram,
    UilFacebookF,
  },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    channelConfigs: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      dropdownPosition: {
        top: '0px',
        left: '0px',
        width: '0px',
      },
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;

      if (this.isDropdownOpen) {
        this.$nextTick(() => {
          const trigger = this.$el.querySelector('.channel-flow-select-trigger');
          const rect = trigger.getBoundingClientRect();

          this.dropdownPosition = {
            top: `${rect.bottom + window.scrollY + 4}px`,
            left: `${rect.left + window.scrollX}px`,
            width: `${rect.width}px`,
          };
        });
      }
    },

    selectChannel(channel, event) {
      event.stopPropagation();

      this.$emit('input', channel); // Atualiza o v-model no pai com o canal completo
      this.$emit('channel-selected', channel); // Emite para o step avançar
      this.isDropdownOpen = false;
    },

    getIconComponent(type_key) {
      const icons = {
        0: UilWhatsapp,
        2: UilInstagram,
        3: UilFacebookF,
      };
      return icons[type_key] || UilFacebookF;
    },
  },

  mounted() {
    const handleClickOutside = (event) => {
      if (this.isDropdownOpen && !this.$el.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    };

    document.addEventListener('click', handleClickOutside);

    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('click', handleClickOutside);
    });
  },
};
</script>
